import { createReducer } from '@reduxjs/toolkit'

import { portfolioCampaignsTableColumnsConfig } from 'configuration/tables/campaignFactsTables'
import {
    DATES,
    CAMPAIGN_BUDGET,
    CAMPAIGN_STATES,
    CAMPAIGN_TARGETING_TYPES,
    AGGREGATION,
    FACT_TYPES,
    CAMPAIGN_NAME,
    LABELS,
    METRIC_FILTERS,
    BID_MULTIPLIERS,
} from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [CAMPAIGN_NAME]: null,
        [FACT_TYPES]: [],
        [CAMPAIGN_BUDGET]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
        [BID_MULTIPLIERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [CAMPAIGN_NAME, DATES, AGGREGATION, FACT_TYPES],
        order: [
            CAMPAIGN_STATES,
            CAMPAIGN_BUDGET,
            CAMPAIGN_TARGETING_TYPES,
            LABELS,
            METRIC_FILTERS,
            BID_MULTIPLIERS,
        ],
        displayState: {},
        userAdded: [CAMPAIGN_STATES],
    },
    table: getDefaultTable(
        serializeColumns(portfolioCampaignsTableColumnsConfig)
    ),
}

export default createReducer(initialState, () => {})
